/* Fablex V8 – isolated enhancement scripts. Horizon's product forms, variant picker,
   inventory and accelerated checkout are left entirely to the native theme. */
(() => {
  'use strict';
  const root = window.Shopify?.routes?.root || '/';
  const GBP = cents => new Intl.NumberFormat('en-GB', {style:'currency',currency:'GBP'}).format(cents/100);
  let cachedTotal = null;
  async function loadCart() {
    const res = await fetch(root + 'cart.js', {credentials:'same-origin'});
    if (!res.ok) throw new Error('Cart unavailable');
    return res.json();
  }
  async function refreshShipping() {
    const bars = document.querySelectorAll('[data-fv8-shipping]');
    if (!bars.length) return;
    try {
      const cart = await loadCart();
      const total = cart.total_price;
      cachedTotal = total;
      for(const bar of bars) {
        const max = Number(bar.dataset.threshold) || 7000;
        const remaining = Math.max(0,max-total);
        const ratio = Math.min(100,Math.max(0,total / max * 100));
        const fill = bar.querySelector('[data-fv8-fill]');
        const text = bar.querySelector('[data-fv8-status]');
        const progress = bar.querySelector('[role=progressbar]');
        if(fill) fill.style.width = ratio + '%';
        if(text) text.textContent = remaining ? GBP(remaining) + ' to go' : '✦ Threshold reached';
        if(progress) progress.setAttribute('aria-valuenow',String(Math.round(Math.min(70,total/100))));
        bar.classList.toggle('is-unlocked',remaining===0);
      }
    } catch(e) {
      document.querySelectorAll('[data-fv8-status]').forEach(el=>{el.textContent='Free over £70';});
    }
  }
  function initPairings() {
    document.querySelectorAll('[data-fv8-pairings]').forEach(section => {
      if(section.dataset.fv8Ready) return;
      section.dataset.fv8Ready = '1';
      const btn = section.querySelector('[data-fv8-add-selected]');
      if (!btn) return;
      const checks = [...section.querySelectorAll('input[data-fv8-variant]')];
      const updateSelection=()=>{btn.disabled=!checks.some(c=>c.checked && c.dataset.fv8Variant)};
      checks.forEach(x=>x.addEventListener('change',updateSelection));
      section.querySelectorAll('[data-fv8-pair-variant-select]').forEach(select=>select.addEventListener('change',()=>{
        const pair=select.closest('[data-fv8-pair]');
        const check=pair?.querySelector('input[data-fv8-variant]');
        const price=pair?.querySelector('[data-fv8-pair-price]');
        if(check){check.dataset.fv8Variant=select.value;check.disabled=!select.value;check.checked=false;}
        if(price && select.selectedOptions[0]?.dataset.price)price.textContent=select.selectedOptions[0].dataset.price;
        updateSelection();
      }));
      btn.addEventListener('click',async()=>{
        const items = checks.filter(c=>c.checked && c.dataset.fv8Variant).map(c=>({id:Number(c.dataset.fv8Variant),quantity:1})).filter(x=>x.id);
        if(!items.length)return;
        const status = section.querySelector('[data-fv8-message]');
        btn.disabled=true; const prev=btn.textContent; btn.textContent='Adding your pieces…';
        try {
          const res = await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},credentials:'same-origin',body:JSON.stringify({items})});
          if(!res.ok){const error=await res.json().catch(()=>null);throw new Error(error?.description||'Could not add selected products');}
          // Navigation to the native cart guarantees that added products and cart totals are in sync.
          window.location.assign(root+'cart');
        } catch(e) {
          if(status)status.textContent=e.message||'Please try again.';
          btn.textContent=prev;btn.disabled=false;
        }
      });
    });
  }
  function initPixel() {
    document.querySelectorAll('[data-fx-playground]').forEach(section=>{
      if(section.dataset.fv8Ready) return;
      section.dataset.fv8Ready='1';
      const canvas=section.querySelector('[data-fx-canvas]');
      const ctx=canvas?.getContext('2d',{willReadFrequently:true});
      const range=section.querySelector('[data-fx-slider]');
      const upload=section.querySelector('[data-fx-upload]');
      const label=section.querySelector('[data-fx-resolution]');
      const count=section.querySelector('[data-fx-cellcount]');
      if(!ctx||!range)return;
      let source=null;
      function demo(which){
        const c=document.createElement('canvas');c.width=512;c.height=512;
        const g=c.getContext('2d');
        g.fillStyle='#142646';g.fillRect(0,0,512,512);
        if(which==='portrait'){
          g.fillStyle='#b77ab7';g.fillRect(80,72,352,340);
          g.fillStyle='#f2c191';g.beginPath();g.arc(256,227,111,0,Math.PI*2);g.fill();
          g.fillStyle='#2f1b45';g.fillRect(103,330,306,182);
          g.fillStyle='#2f1b45';g.fillRect(212,218,27,30);g.fillRect(308,218,27,30);
        } else {
          g.fillStyle='#e5aa9f';g.fillRect(0,260,512,252);
          g.fillStyle='#f4dbb3';g.beginPath();g.arc(363,124,74,0,Math.PI*2);g.fill();
          g.fillStyle='#1c2c52';g.beginPath();g.moveTo(0,425);g.lineTo(121,209);g.lineTo(254,424);g.lineTo(364,292);g.lineTo(512,405);g.lineTo(512,512);g.lineTo(0,512);g.fill();
          g.fillStyle='#253b69';g.fillRect(0,436,512,76);
        }
        return c;
      }
      function render(){
        const n=range.value==='0'?32:64;
        canvas.width=n;canvas.height=n;ctx.imageSmoothingEnabled=true;
        ctx.fillStyle='#141628';ctx.fillRect(0,0,n,n);
        if(source){
          const w=source.width,h=source.height;
          const size=Math.min(w,h);
          const x=Math.floor((w-size)/2),y=Math.floor((h-size)/2);
          ctx.drawImage(source,x,y,size,size,0,0,n,n);
          // Pixel canvas is physically n x n; every resulting cell contains a SINGLE flat RGBA value.
          // Nearest-neighbour enlargement prevents any mixed/interpolated colours inside the cells.
        }
        canvas.style.imageRendering='pixelated';
        canvas.setAttribute('aria-label',n+' by '+n+' solid-colour pixel preview');
        label.textContent=n+' × '+n+' PIXELS';
        count.textContent=n.toLocaleString('en-GB')+' × '+n+' = '+(n*n).toLocaleString('en-GB')+' solid-colour pixels';
      }
      source=demo('landscape');render();range.addEventListener('input',render);
      section.querySelectorAll('[data-fx-example]').forEach(btn=>btn.addEventListener('click',()=>{
        if(source?.close)source.close();source=demo(btn.dataset.fxExample);
        section.querySelectorAll('[data-fx-example]').forEach(b=>b.classList.toggle('is-active',b===btn));
        if(upload)upload.value='';render();
      }));
      upload?.addEventListener('change',async()=>{
        const file=upload.files?.[0];if(!file)return;
        if(file.size>8*1024*1024){alert('Choose an image under 8 MB.');upload.value='';return;}
        try {const img=await createImageBitmap(file);if(source?.close)source.close();source=img;render();}
        catch(e){alert('We could not open that file. Try a JPEG, PNG or WebP image.');}
      });
    });
  }
  function initCompare(){
    document.querySelectorAll('[data-fv8-compare]').forEach(section=>{
      if(section.dataset.fv8Ready)return;section.dataset.fv8Ready='1';
      const range=section.querySelector('[data-fx-compare-range]');
      const before=section.querySelector('[data-fx-before]');
      const divider=section.querySelector('[data-fx-divider]');
      if(!range||!before)return;
      const update=()=>{const v=Math.max(0,Math.min(100,Number(range.value)));before.style.clipPath=`inset(0 ${100-v}% 0 0)`;if(divider)divider.style.left=v+'%'};
      range.addEventListener('input',update);update();
    });
  }
  function initExplorer(){
    document.querySelectorAll('[data-fv8-explorer]').forEach(section=>{
      if(section.dataset.fv8Ready)return;section.dataset.fv8Ready='1';
      const image=section.querySelector('[data-fv8-explorer-image]');
      const counter=section.querySelector('[data-fv8-image-counter]');
      section.querySelectorAll('[data-fv8-explorer-choice]').forEach(button=>button.addEventListener('click',()=>{
        if(!image)return;
        image.src=button.dataset.image;image.alt=button.dataset.alt||'Product detail';
        if(counter)counter.textContent=String(button.dataset.index).padStart(2,'0');
        section.querySelectorAll('[data-fv8-explorer-choice]').forEach(b=>{
          b.classList.toggle('is-selected',b===button);
          b.setAttribute('aria-pressed',b===button?'true':'false');
        });
      }));
    });
  }
  function initSticky(){
    const bar=document.querySelector('[data-fv8-sticky]');
    if(!bar || bar.dataset.fv8Ready)return;
    bar.dataset.fv8Ready='1';
    const main=document.querySelector('.product-information');
    const buy=main?.querySelector('button[name="add"], button[type="submit"], .add-to-cart-button');
    if(!main||!buy)return;
    const button=bar.querySelector('button');
    button?.addEventListener('click',()=>{buy.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'center'});buy.focus({preventScroll:true});});
    const observer=new IntersectionObserver(entries=>{
      const show=!entries[0].isIntersecting && entries[0].boundingClientRect.bottom < 0;
      bar.classList.toggle('is-visible',show);
      bar.setAttribute('aria-hidden',show?'false':'true');
    },{threshold:0});
    observer.observe(buy);
  }
  function init(){refreshShipping();initPairings();initPixel();initCompare();initExplorer();initSticky()}
  document.addEventListener('DOMContentLoaded',init);
  document.addEventListener('shopify:section:load',init);
  document.addEventListener('cart:updated',refreshShipping);
  document.addEventListener('cart:refresh',refreshShipping);
  // Update the visual progress after normal cart mutations, without modifying Horizon's cart flow.
  const cartDrawer=document.querySelector('cart-drawer,cart-drawer-component');
  if(cartDrawer){let scheduled;new MutationObserver(()=>{clearTimeout(scheduled);scheduled=setTimeout(refreshShipping,400)}).observe(cartDrawer,{childList:true,subtree:false});}
})();
